import Button from "@material-ui/core/Button";
import Progress from "@material-ui/core/CircularProgress";
import React from "react";

const LoadingButton = ({
  isLoading,
  disabled,
  loadingSize = 24,
  children,
  color,
  onClick,
  style,
  variant,
  fullWidth,
  className,
}) => {
  const handleOnClick = () => {
    if (!isLoading && !disabled) {
      onClick();
    }
  };
  return (
    <Button
      className={className}
      style={style}
      variant={variant}
      color={color}
      disabled={isLoading || disabled}
      onClick={handleOnClick}
      fullWidth={fullWidth}
    >
      {isLoading ? <Progress size={loadingSize} color={color} /> : children}
    </Button>
  );
};

export default LoadingButton;
